import LySearchSelect from './src/index.vue'

LySearchSelect.install = function (Vue) {
    Vue.component(LySearchSelect.name, LySearchSelect)
}

export default LySearchSelect


//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/search-select/index.js
// module id = null
// module chunks = 